import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Avatar from '../../../../../../components/Avatar';
import LinkCandidateProfile from '../../../../../../components/LinkCandidateProfile';
import LoadMask from '../../../../../../components/LoadMask';
import {CONNECT_STATUS} from '../../../../../../constants/profile';
import LinkBuilder from '../../../../../../helpers/link-builder';
import {Role} from '../../../../../../helpers/user';
import {useNetworkActions} from '../../../../../../hooks/useNetworkActions';
import ConnectionsItemStatus from './components/ConnectionsItemStatus';
import './styles.css';

const ConnectionsItem = props => {
  const {
    user,
    person: {
      ConnectStatus,
      ConnectedID,
      FullName,
      PictureUrl,
      FirmName,
      FirmUrlAlias,
      FirmActive,
      UGSchoolName,
      Token,
      ViewProfile,
      ViewAsRecruiter,
    },
    onChangeStatus,
    onSendMessage,
  } = props;

  const [
    isPending,
    { accept, reject, disconnect, connect },
  ] = useNetworkActions();

  const handleAction = action => {
    if (
      action === 'message' &&
      onSendMessage &&
      typeof onSendMessage === 'function'
    ) {
      onSendMessage(ConnectedID, FullName);
      return;
    }

    if (!Role.isCandidate(user, true) || isPending) {
      return;
    }

    const isHandlerInit =
      onChangeStatus && typeof onChangeStatus === 'function';

    if (action === 'accept') {
      accept(Token).then(() =>
        onChangeStatus(props.person, CONNECT_STATUS.CONNECTED)
      );
    }

    if (action === 'reject') {
      reject(Token).then(
        () =>
          isHandlerInit &&
          onChangeStatus(props.person, CONNECT_STATUS.NOT_CONNECTED)
      );
    }

    if (action === 'disconnect') {
      disconnect(ConnectedID).then(
        () =>
          isHandlerInit &&
          onChangeStatus(props.person, CONNECT_STATUS.NOT_CONNECTED)
      );
    }

    if (action === 'connect') {
      connect(ConnectedID).then(
        () =>
          isHandlerInit &&
          onChangeStatus(props.person, CONNECT_STATUS.REQUIRE_APPROVE)
      );
    }
  };

  return (
    <div className="connections-block__item">
      {isPending && <LoadMask relative />}
      <div className="connections-block__item-visual">
        <div className="connections-block__item-avatar">
          <Avatar size={55} name={FullName} image={PictureUrl} />
        </div>
        <ConnectionsItemStatus status={ConnectStatus} onClick={handleAction} />
      </div>
      <div className="connections-block__item-content">
        <LinkCandidateProfile
          cls="connections-block__item-name"
          clsSpan="connections-block__item-span"
          user={user}
          id={ConnectedID}
          name={FullName}
          viewAsRecruiter={ViewAsRecruiter === 'Yes'}
          viewProfile={ViewProfile === 'Yes'}
        />

        {FirmName &&
          (FirmActive === 'Yes' ? (
            <NavLink
              to={LinkBuilder.getFirmLink(FirmUrlAlias)}
              className="connections-block__item-link"
            >
              {FirmName}
            </NavLink>
          ) : (
            <span className="related-people-block__person-place">
              {FirmName}
            </span>
          ))}

        <span className="connections-block__item-place">{UGSchoolName}</span>
      </div>
    </div>
  );
};

ConnectionsItem.propTypes = {
  user: PropTypes.object,
  person: PropTypes.object.isRequired,
  onChangeStatus: PropTypes.func,
  onSendMessage: PropTypes.func,
};

export default ConnectionsItem;
